import React, {useEffect, useState} from 'react';
import RadioGroupInput from "../radioGroupInput";
import './radiogroup.css';

const RadioGroup = props => {
    const [list, setList] = useState([]);
    useEffect(() => {
        const answers = props.questions;
        let groups = [];
        answers.forEach((el) => {
            el.answers.forEach((item) => {
                groups.push({value: item.group, isActive: props.activeGroup == item.group});
            })
        });
        const doRender = groups.filter(el => {
            return el.value ? el.value.length : 0
        });
        if(doRender.length) {
            const list = groups.filter(el => el.value);
            const result = filterByProp(list, 'value');
            setList(result);
        }
    }, [props]);

    const filterByProp = (arr, prop) => {
        let obj = {};
        return arr.filter(item => {
            if (obj[item[prop]]) {
                return false;
            } else {
                obj[item[prop]] = true;
                return true;
            }
        });
    }

    return (
        <div className="radio-tabs">
            <div className="radio-tabs__title">Выберите группу</div>
            <div className="radio-tabs__list">
                {list.length ? list.map((el) =>
                    <RadioGroupInput
                        changeResultGroup={props.changeResultGroup}
                        list={list}
                        isChecked={el.isActive}
                        key={el.value}
                        index={props.index}
                        el={el}/>
                ) : ''}
            </div>
        </div>
    );
};

export default RadioGroup;
